import { createSlice } from '@reduxjs/toolkit';
import { ReturnDetailStateType } from 'src/types/returnDetail';

const initialState: ReturnDetailStateType = {
    data: null,
    changelog: null,
    loading: false,
    error: false,
};
export const returnDetailSlice = createSlice({
    name: 'returnDetail',
    initialState,
    reducers: {
        getReturnDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getReturnDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.changelog = null;
            state.loading = false;
        },
        getReturnDetailFetchFailure: (state, action) => {
            state.data = null;
            state.changelog = null;
            state.loading = false;
            state.error = true;
        },
        getReturnDetailChangelogFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getReturnDetailChangelogFetchSuccess: (state, action) => {
            state.changelog = action.payload.data;
            state.loading = false;
        },
        getReturnDetailChangelogFetchFailure: (state, action) => {
            state.changelog = null;
            state.loading = false;
            state.error = true;
        },
        createReturnDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        createReturnDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
            state.changelog = null;
        },
        createReturnDetailFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
            state.changelog = null;
        },
        updateReturnDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        updateReturnDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
            state.changelog = null;
        },
        updateReturnDetailFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
            state.changelog = null;
        },
        patchReturnDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        patchReturnDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
            state.changelog = null;
        },
        patchReturnDetailFetchFailure: (state, action) => {
            state.loading = false;
            state.error = true;
            state.changelog = null;
        },
        editReturnDetailEshopNoteFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        editReturnDetailEshopNoteFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
            state.changelog = null;
        },
        editReturnDetailEshopNoteFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
            state.changelog = null;
        },
        confirmReturnDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        confirmReturnDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
            state.changelog = null;
        },
        confirmReturnDetailFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
            state.changelog = null;
        },
        setReturnDetailData: (state, action) => {
            state.data = action.payload;
        },
        clearReturnDetail: () => initialState,
    },
});

export const {
    getReturnDetailFetch,
    getReturnDetailFetchSuccess,
    getReturnDetailFetchFailure,
    getReturnDetailChangelogFetch,
    getReturnDetailChangelogFetchSuccess,
    getReturnDetailChangelogFetchFailure,
    createReturnDetailFetch,
    createReturnDetailFetchSuccess,
    createReturnDetailFetchFailure,
    updateReturnDetailFetch,
    updateReturnDetailFetchSuccess,
    updateReturnDetailFetchFailure,
    patchReturnDetailFetch,
    patchReturnDetailFetchSuccess,
    patchReturnDetailFetchFailure,
    editReturnDetailEshopNoteFetch,
    editReturnDetailEshopNoteFetchSuccess,
    editReturnDetailEshopNoteFetchFailure,
    confirmReturnDetailFetch,
    confirmReturnDetailFetchSuccess,
    confirmReturnDetailFetchFailure,
    setReturnDetailData,
    clearReturnDetail,
} = returnDetailSlice.actions;

export default returnDetailSlice.reducer;
